import { render } from "./TableHeadTooltip.vue?vue&type=template&id=4c265eb1&scoped=true"
import script from "./TableHeadTooltip.vue?vue&type=script&lang=js"
export * from "./TableHeadTooltip.vue?vue&type=script&lang=js"

import "./TableHeadTooltip.vue?vue&type=style&index=0&id=4c265eb1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c265eb1"]])

export default __exports__